import { BaseHttpProvider } from "providers/base-http.provider"

export class LegalProvider extends BaseHttpProvider {
  getCookiesPageData = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/cookies-policies-collections/find",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }
  getRecurringPageData = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/recurring-policies-collections/find",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }
  getRefundPageData = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/refund-policies-collections/find",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }
  getCaliforniaPrivacyPageData = async (date?: string) => {
    return await this.execute({
      uri: "/california-privacies/find",
      query: {
        effective_date: date,
      },
    })
  }
  getPrivacyLastOrByDate = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/privacy-policies/find",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }

  getTermsLastOrByDate = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/terms-and-conditions/find",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }

  getConsumerHealthLastOrByDate = async (locale: string, date?: string) => {
    return await this.execute({
      uri: "/consumer-health-policies",
      query: {
        effective_date: date,
        locale,
      },
    })
  }

  getAccountDeletionPageData = async () => {
    return await this.execute({
      uri: "/google-account-deletion-page",
    })
  }

  getReportingContentPageData = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/reporting-content-policies",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }

  getPrivacyPolicyForCaliforniaPageData = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/privacy-policies-for-californias",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }

  getChildSafetyPageData = async (
    locale: string,
    date?: string,
    countryCode?: string,
  ) => {
    return await this.execute({
      uri: "/child-safety",
      query: {
        effective_date: date,
        country_code: countryCode,
        locale,
      },
    })
  }

  getValentinesDayTermsPageData = async (locale: string) => {
    return await this.execute({
      uri: "/valentines-day-terms",
      query: {
        locale,
      },
    })
  }

  getColoradoSafetyPageData = async (date?: string) => {
    return await this.execute({
      uri: "/colorado-safety-policies",
      query: {
        effective_date: date,
      },
    })
  }
}
